import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/phone.png';
var _hoisted_1 = { class: "scenic-food-info-card" };
var _hoisted_2 = { class: "picture" };
var _hoisted_3 = ["src"];
var _hoisted_4 = { class: "info" };
var _hoisted_5 = { class: "name" };
var _hoisted_6 = { class: "phone" };
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: "地標圖"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
                src: (_a = _ctx.tourisnInfo.Picture) === null || _a === void 0 ? void 0 : _a.PictureUrl1,
                alt: "景點美食照"
            }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.tourisnInfo.Name), 1),
            _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.tourisnInfo.Phone), 1)
            ])
        ])
    ]));
}
